var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.344 477.656C189.469 480.781 194.531 480.781 197.656 477.656L349.656 325.656C351.219 324.094 352 322.062 352 320S351.219 315.906 349.656 314.344C346.531 311.219 341.469 311.219 338.344 314.344L200 452.688V136C200 131.594 196.422 128 192 128S184 131.594 184 136V452.688L45.656 314.344C42.531 311.219 37.469 311.219 34.344 314.344S31.219 322.531 34.344 325.656L186.344 477.656ZM8 48H376C380.418 48 384 44.418 384 40S380.418 32 376 32H8C3.582 32 0 35.582 0 40S3.582 48 8 48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFromLine);
export default __webpack_public_path__ + "static/media/arrow-down-from-line.4e8f2fe7a5cf0cff1d258d04d2d4123c.svg";
export { ForwardRef as ReactComponent };